/**
 * Definition of the AccountUtil instance.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2026
 */

import { getAccountUtil } from '@amplify3/duplo-back-end'
import { baseURL } from './env'
export const accountUtil = getAccountUtil(baseURL)
